import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/common.css";
import "bootstrap/dist/css/bootstrap-reboot.css";
import "./assets/css/bootstrap-grid-used.css";
import "./assets/css/bootstrap-used.css";
import "./assets/css/responsive.css";

createApp(App).use(store).use(router).mount("#app");
